import { JsonSchemaValidator } from "@common/json-schema-validator";
import { BrandCaptionLowerThirdEntityRaw } from "../../interface";
import { brandCaptionLowerThirdEntityRaw } from "../../schema";
import { BaseEntity } from "../base.entity";

export class BrandCaptionLowerThirdEntity extends BaseEntity<BrandCaptionLowerThirdEntityRaw> {
  private static validation = JsonSchemaValidator.compile(
    brandCaptionLowerThirdEntityRaw
  );

  constructor(value: BrandCaptionLowerThirdEntityRaw) {
    super(
      JsonSchemaValidator.assert(BrandCaptionLowerThirdEntity.validation, value)
    );
  }
}
